export const formName = 'fileWizard';

export const fieldName = 'fileName';
